import { FC, ReactNode } from 'react'
import { AppFeatureGate } from 'src/components/app-feature/AppFeatureGate'
import { UseAppFeatureOptions } from 'src/hooks/useAppFeature'

type Props = {
  integrationKey?: string
  featureKey?: string
  element: ReactNode
  redirectTo?: string
} & UseAppFeatureOptions

/**
 * React-router element wrapper — use integrationKey (wired once in code, linked in DB).
 * scope defaults to auto (per-customer in client admin, global elsewhere).
 */
export const FeatureRoute: FC<Props> = ({
  integrationKey,
  featureKey,
  element,
  accessField,
  redirectTo,
  scope,
  customerId,
}) => (
  <AppFeatureGate
    integrationKey={integrationKey}
    featureKey={featureKey}
    accessField={accessField}
    redirectTo={redirectTo}
    scope={scope}
    customerId={customerId}
  >
    {element}
  </AppFeatureGate>
)
